export const ZALO_TEMPLATE_PERMISSION = {
  VIEW: 'ZALO_TEMPLATE_VIEW',
  ADD: 'ZALO_TEMPLATE_ADD',
  EDIT: 'ZALO_TEMPLATE_EDIT',
  DEL: 'ZALO_TEMPLATE_DEL',
};
